import React from "react";
import Section from "../components/Section";
import { ToggleSwitch } from "payzli-ui";

const ToggleSwitchSection = () => {
	const [state, setState] = React.useState<any>({
		check1: false,
		check2: false,
		check3: false,
		check4: true,
		check5: true,
		check6: true
	});
	const handleToggle = (checked: boolean, name: string) => {
		setState({ ...state, [name]: checked });
	};
	return (
		<Section title={"# Toggle Switch"}>
			<div className="d-flex justify-content-center flex-direction-column align-items-center gap2">
				<div className="d-flex gap2">
					<ToggleSwitch size="xs" checked={state.check1} onToggle={(checked) => handleToggle(checked, "check1")} />
					<ToggleSwitch size="sm" checked={state.check2} onToggle={(checked) => handleToggle(checked, "check2")} />
					<ToggleSwitch size="md" checked={state.check3} onToggle={(checked) => handleToggle(checked, "check3")} />
				</div>
				<div className="d-flex gap2">
					<ToggleSwitch size="xs" checked={state.check4} onToggle={(checked) => handleToggle(checked, "check4")} />
					<ToggleSwitch size="sm" checked={state.check5} onToggle={(checked) => handleToggle(checked, "check5")} />
					<ToggleSwitch size="md" checked={state.check6} onToggle={(checked) => handleToggle(checked, "check6")} />
				</div>
				<div className="d-flex gap2">
					<ToggleSwitch disabled={true} size="xs" checked={state.check1} onToggle={(checked) => handleToggle(checked, "check1")} />
					<ToggleSwitch disabled={true} size="sm" checked={state.check2} onToggle={(checked) => handleToggle(checked, "check2")} />
					<ToggleSwitch disabled={true} size="md" checked={state.check3} onToggle={(checked) => handleToggle(checked, "check3")} />
				</div>
			</div>
		</Section>
	);
};

export default ToggleSwitchSection;
